// extracted by mini-css-extract-plugin
export var bgDark = "ClickableImageComponentStyle-module--bg-dark--2E5Hr";
export var container = "ClickableImageComponentStyle-module--container--3fel_";